<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="box-seam" class="icon"></b-icon>
            <span>สินค้าในร้าน</span>
        </div>

        <div class="content">
            <div class="filter form mb-4">
                <stock-lookup-filter @lookup="filterInventoryList($event)"></stock-lookup-filter>
            </div>

            <div class="mb-4 text-right">
                <button class="btn btn-green" @click="openModalInventory(null)">เพิ่มรายการสินค้า</button>
            </div>

            <perfect-scrollbar>
                <table>
                    <thead>
                        <tr>
                            <th class="action-column"></th>
                            <th>รุ่นสินค้า</th>
                            <th>ยี่ห้อ</th>
                            <th>ราคา</th>
                            <th>จำนวนสต๊อค</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in inventoryList.filter((value, index) => $AppUtility.renderByPage(this.activePage, this.pageSize, index))" :key="index">
                            <td class="text-center text-nowrap">
                                <button class="icon" @click="openModalInventory(item)"><b-icon icon="pencil"></b-icon></button>
                                <button class="icon" @click="deleteStock(item)"><b-icon icon="trash"></b-icon></button>
                            </td>
                            <td>
                                <span class="text-nowrap" v-if="item.inventoryData.sku">SKU: {{ item.inventoryData.sku }}</span>
                                {{ item.productData.name }}
                            </td>
                            <td>{{ item.productData.brand }}</td>
                            <td>
                                <div class="data-number">
                                    <label>ต้นทุนเฉลี่ย</label><span>{{ appHelper.getCommaNumber(item.inventoryData.cost) }}</span>
                                </div>
                                <div class="data-number">
                                    <label>ราคาขาย</label><span>{{ appHelper.getCommaNumber(item.inventoryData.price) }}</span>
                                </div>
                            </td>
                            <td>
                                <div class="data-number">
                                    <label>คงเหลือ (ของร้าน)</label><span>{{ appHelper.getCommaNumber($AppUtility.getAvailableStock(item.stockData, 'amountNormal')) }}</span>
                                </div>
                                <div class="data-number">
                                    <label>คงเหลือ (สินค้าโป๊ว)</label><span>{{ appHelper.getCommaNumber($AppUtility.getAvailableStock(item.stockData, 'amountSublet')) }}</span>
                                </div>
                                <div class="data-number">
                                    <label>คงเหลือ (ฝากขาย)</label><span>{{ appHelper.getCommaNumber($AppUtility.getAvailableStock(item.stockData, 'amountConsign')) }}</span>
                                </div>
                                <div class="data-number">
                                    <label>ถูกจอง</label><span>{{ appHelper.getCommaNumber(item.stockData.reserve) }}</span>
                                </div>
                                <div class="mt-2">
                                    <button class="btn btn-block btn-sm btn-grey-outline" @click="openModalStock(item)">ปรับจำนวนสต๊อค</button>
                                </div>
                                <div class="mt-1">
                                    <button class="btn btn-block btn-sm btn-grey-outline" @click="openModalStockOther(item)">เช็คสต๊อคที่อื่น</button>
                                </div>
                            </td>
                            <td><div class="text-center"><button class="btn btn-sm btn-blue text-nowrap" @click="openModalSpec(item)" v-if="item.productData.hasSpec">ดูสเปค</button></div></td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>

            <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

            <div class="no-data" v-if="inventoryList.length === 0 && !isLoading">
                <b-icon icon="exclamation-diamond"></b-icon>
                <span>ไม่พบรายการสินค้าในร้าน</span>
            </div>

            <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="inventoryList.length" class="mt-4"></paging>
        </div>

        <inventory-modal-inventory-data
            :isDisplay="modalInventoryOption.isShowModal"
            :editData="modalInventoryOption.editData"
            @hide="closeModalInventory($event)">
        </inventory-modal-inventory-data>

        <inventory-modal-stock
            :isDisplay="modalStockOption.isShowModal"
            :contentData="modalStockOption.selectedData"
            @stockUpdate="stockUpdate($event)"
            @hide="closeModalStock()">
        </inventory-modal-stock>

        <inventory-modal-product-spec
            :isDisplay="modalSpecOption.isShowModal"
            :productData="modalSpecOption.productData" 
            @hide="closeModalSpec()">
        </inventory-modal-product-spec>

        <inventory-modal-stock-other
            :isDisplay="modalStockOtherOption.isShowModal"
            :contentData="modalStockOtherOption.selectedData" 
            @hide="closeModalStockOther()">
        </inventory-modal-stock-other>
    </div>
</template>

<script>
import InventoryModalInventoryData from '@/components/inventory/ModalInventoryData';
import InventoryModalStock from '@/components/inventory/ModalStock';
import InventoryModalProductSpec from '@/components/inventory/ModalProductSpec';
import InventoryModalStockOther from '@/components/inventory/ModalStockOther';
import StockLookupFilter from '@/components/utility/StockLookupFilter';
import Helper from '@/resources/Helper';
import DBInventory from '@/database/Inventory';
import DBStock from '@/database/Stock';
import DBMasterProduct from '@/database/MasterProduct';
import ModelStockFilter from '@/resources/models/StockFilter';

export default {
    components: {
        InventoryModalInventoryData,
        InventoryModalStock,
        InventoryModalProductSpec,
        InventoryModalStockOther,
        StockLookupFilter
    },
    data() {
        return {
            modalInventoryOption: this.initModalInventoryOption(),
            modalStockOption: this.initModalStockOption(),
            modalSpecOption: this.initModalSpecOption(),
            modalStockOtherOption: this.initModalStockOtherOption(),
            inventoryList: [],
            inventoryFilter: ModelStockFilter.data(),
            isLoading: false, 
            activePage: 1,
            pageSize: 50,
            appHelper: Helper
        }
    },
    mounted() {
        this.loadInventoryList();
    },
    methods: {
        initModalInventoryOption() {
            return {
                isShowModal: false,
                stockData: null
            };
        },
        initModalStockOption() {
            return {
                isShowModal: false,
                selectedData: null
            };
        },
        initModalSpecOption() {
            return {
                isShowModal: false,
                productData: null
            };
        },
        initModalStockOtherOption() {
            return {
                isShowModal: false,
                selectedData: null
            };
        },
        openModalStockOther(item) {
            this.modalStockOtherOption = {
                isShowModal: true,
                selectedData: item
            };
        },
        closeModalStockOther() {
            this.modalStockOtherOption = this.initModalStockOtherOption();
        },
        openModalInventory(item) {
            this.modalInventoryOption = {
                isShowModal: true,
                editData: item
            };
        },
        closeModalInventory(data) {
            if (data) {
                this.saveInventory(data);
            }

            this.modalInventoryOption = this.initModalInventoryOption();
        },
        openModalStock(item) {
            this.modalStockOption = {
                isShowModal: true,
                selectedData: item
            };
        },
        closeModalStock() {
            this.modalStockOption = this.initModalStockOption();
            this.loadInventoryList();
        },
        openModalSpec(item) {
            this.modalSpecOption = {
                isShowModal: true,
                productData: item.productData
            };
        },
        closeModalSpec() {
            this.modalSpecOption = this.initModalSpecOption();
        },
        filterInventoryList(value) {
            this.inventoryFilter = value;
            this.loadInventoryList();
        },
        async loadInventoryList() {
            this.isLoading = true;
            this.inventoryList = [];

            // Sync Master Data
            await DBMasterProduct.sync();

            // Load Inventory Data
            const inventory = await DBInventory.get();
            const stock = await DBStock.get();

            if (inventory.content && inventory.content.length > 0) {
                // Merge Object
                let result = this.mergeObject(inventory.content, stock.content);

                // Filter Result
                result = await this.$AppUtility.inventoryFilterResult(result, this.inventoryFilter);

                // Map and Place into the Object
                this.inventoryList = await this.mapViewData(result);
            }

            // Done Loading
            this.isLoading = false;
        },
        mergeObject(inventoryList, stockList) {
            let result = [];

            inventoryList.forEach((inventory) => {
                const stock = stockList.find(x => x.key === inventory.key);
                const obj = inventory;

                obj['stockData'] = {
                    dots: stock.dots,
                    reserve: stock.reserve
                };

                result.push(obj);
            });

            return result;
            
        },
        async mapViewData(content) {
            const data = [];

            for (const item of content) {
                data.push({
                    key: item.key,
                    productData: item.productData,
                    inventoryData: item.inventoryData,
                    stockData: item.stockData
                });
            }

            return data;
        },
        stockUpdate(data) {
            this.modalStockOption.selectedData.stockData = data;
        },
        async saveInventory(data) {
            const loader = this.$AppUtility.renderLoadBackdrop();
            const isUpdate = data.key ? true : false;
            const save = await DBInventory.save(data);

            // Initial Stock
            if (!isUpdate) {
                await DBStock.initialStock(save.key);
            }

            this.loadInventoryList();
            loader.hide();
        },
        deleteStock(item) {
            this.$swal({
                title: 'ลบสต๊อคสินค้า?',
                text: 'โปรดยืนยันว่าต้องการลบสต๊อคสินค้าออกจากร้าน',
                icon: 'question',
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const loader = this.$AppUtility.renderLoadBackdrop();

                    await DBInventory.delete(item);

                    this.loadInventoryList();
                    loader.hide();
                }
            });
        },
        changePage(value) {
            this.activePage = value;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

table {
    td {
        vertical-align: top;
    }
}
</style>